import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';

export const NoOptionsMessage = () => (
    <div className="orca-combo-box__no-options">
        <I18n k="orca.comboBox.noOptions"/>
    </div>);

NoOptionsMessage.displayName = 'NoOptionsMessage';

export default NoOptionsMessage;
